import { render, staticRenderFns } from "./Nivel2.vue?vue&type=template&id=ac1f2466&"
import script from "./Nivel2.vue?vue&type=script&lang=js&"
export * from "./Nivel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports